import React from "react";
import { Link } from "react-router-dom";
import CategorySidebar from "../../services/CategorySidebar";

import complete_house_cleaning_img from "../../images/stage_01/complete_house_cleaning.png";
import electrical_img from "../../images/stage_01/electrical.png";
import elder_caretaker_img from "../../images/stage_01/elder_caretaker_R2.png";
import gardening_img from "../../images/stage_01/gardening_main.png";
import packers_movers_img from "../../images/stage_01/complete_packers_movers.png";
import special_service_img from "../../images/stage_01/special_service.png";

const fallbackImage =
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80";

// Same cross-links OutdoorServices.js offers, plus a way back to Outdoor
// Services itself, so a visitor landing here isn't stuck — just redirected
// to Coming Soon instead of the live Car Wash booking form (see App.js).
const extraServices = [
  { name: "Outdoor Services",   link: "/services/outdoor-services",      image: gardening_img },
  { name: "Home Services",      link: "/services/instant-home-services", image: complete_house_cleaning_img },
  { name: "Technical Services", link: "/services/technical-services",    image: electrical_img },
  { name: "Caretaker Services", link: "/services/caretaker-services",    image: elder_caretaker_img },
  { name: "Transport Services", link: "/services/transport-services",    image: packers_movers_img },
  { name: "Special Services",   link: "/services/special-services",      image: special_service_img },
];

const CarWashServiceComingSoon = () => {
  return (
    <div style={styles.page}>
      <div style={styles.layout}>
        <aside style={styles.sidebar}>
          <CategorySidebar />

          <div style={styles.helpCard}>
            <h4 style={styles.helpTitle}>Need Help with Outdoor Work?</h4>
            <p style={styles.helpText}>Book reliable outdoor experts for cleaning and maintenance.</p>
            <Link to="/contact-us" style={{ ...styles.chatBtn, display: "inline-block", textDecoration: "none", textAlign: "center" }}>💬 Chat with Expert</Link>
            <div style={styles.helpIcon}>🚗</div>
          </div>
        </aside>

        <main style={styles.main}>
          <div style={styles.breadcrumb}>
            <Link to="/" style={styles.breadcrumbLink}>Home</Link> &gt;{" "}
            <Link to="/services/outdoor-services" style={styles.breadcrumbLink}>Outdoor Services</Link> &gt; Car Wash at Home
          </div>

          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Car Wash at Home</h2>
          </div>

          <div style={styles.comingSoonCard}>
            <div style={styles.comingSoonIcon}>🚗</div>
            <h3 style={styles.comingSoonTitle}>Coming Soon</h3>
            <p style={styles.comingSoonText}>
              Car Wash at Home isn't available for booking yet — check back soon.
            </p>
          </div>

          <div style={styles.exploreSection}>
            <h3 style={styles.exploreTitle}>Explore Other Services</h3>
            <div style={styles.exploreGrid}>
              {extraServices.map((item, index) => (
                <Link key={index} to={item.link} style={styles.exploreCardLink}>
                  <div style={styles.exploreCard}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={styles.exploreImage}
                      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
                    />
                    <div style={styles.exploreCardBody}>
                      <h4 style={styles.exploreName}>{item.name}</h4>
                      <span style={styles.exploreLink}>Check Now →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const styles = {
  page:             { background: "#f8fafc", minHeight: "100vh", padding: "20px", fontFamily: "Arial, sans-serif", color: "#111827" },
  layout:           { maxWidth: "1600px", margin: "0 auto", display: "grid", gridTemplateColumns: "250px 1fr", gap: "20px", alignItems: "start" },
  sidebar:          { display: "flex", flexDirection: "column", gap: "18px" },
  helpCard:         { background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: "18px", padding: "18px", textAlign: "left" },
  helpTitle:        { margin: "0 0 8px", fontSize: "18px", fontWeight: 700 },
  helpText:         { margin: "0 0 14px", fontSize: "14px", color: "#6b7280", lineHeight: 1.6 },
  chatBtn:          { border: "none", background: "#fff", color: "#4f46e5", fontWeight: 700, borderRadius: "12px", padding: "12px 16px", cursor: "pointer" },
  helpIcon:         { fontSize: "54px", textAlign: "center", marginTop: "18px" },
  main:             { minWidth: 0 },
  breadcrumb:       { fontSize: "13px", color: "#9ca3af", marginBottom: "14px" },
  breadcrumbLink:   { color: "#9ca3af", textDecoration: "none" },
  sectionHeader:    { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  sectionTitle:     { margin: 0, fontSize: "24px", fontWeight: 700 },

  comingSoonCard:   { background: "#fff", border: "1.5px dashed #e5e7eb", borderRadius: "18px", padding: "56px 24px", textAlign: "center" },
  comingSoonIcon:   { fontSize: "40px", marginBottom: "12px" },
  comingSoonTitle:  { margin: "0 0 8px", fontSize: "22px", fontWeight: 800 },
  comingSoonText:   { margin: 0, fontSize: "14px", color: "#6b7280" },

  exploreSection:   { marginTop: "32px" },
  exploreTitle:     { margin: "0 0 14px", fontSize: "24px", fontWeight: 700 },
  exploreGrid:      { display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: "12px" },
  exploreCardLink:  { textDecoration: "none", color: "inherit" },
  exploreCard:      { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", textAlign: "left" },
  exploreImage:     { width: "100%", aspectRatio: "1 / 1", objectFit: "cover", display: "block", background: "#f3f4f6" },
  exploreCardBody:  { padding: "14px" },
  exploreName:      { margin: "0 0 10px", fontSize: "15px", fontWeight: 700 },
  exploreLink:      { color: "#4f46e5", fontWeight: 700, fontSize: "13px" },
};

export default CarWashServiceComingSoon;
